<div [class.alert-danger]="type === 'failure'"
     [class.alert-info]="type === 'info'"
     [class.alert-success]="type === 'success'"
     [class.invisible]="!show"
     class="alert">

    <div class="media">
        <i *ngIf="type === 'success'" class="fa fa-check-circle-o fa-3x mr-3"></i>
        <i *ngIf="type === 'failure'" class="fa fa-exclamation-circle fa-3x mr-3"></i>
        <i *ngIf="type === 'info'" class="fa fa-info-circle fa-3x mr-3"></i>
        <div class="media-body mt-2">
            <span [innerHTML]="message" class="lead"></span>
        </div>
    </div>
</div>
